module.exports = __webpack_public_path__ + "img/iPhone-cars-bot.09dc96f6.webp";